import { IDestinationFilter } from './IDestinationFilter';
import { TrackedPage } from '../trackedpages';
import { TrackedEvent } from '../trackedEvent';

export abstract class DestinationFilterBase implements IDestinationFilter {
    protected abstract supportedEvents: TrackedEvent[];
    protected abstract supportedPages: TrackedPage[];

    public abstract destinationName: string;

    public isEventExcluded = (event: TrackedEvent, properties: any) => {
        if (event == TrackedEvent.PageViewed) {
            return !this.supportedPages.some((x) => TrackedPage[x].toLowerCase() == properties.page.toLowerCase());
        } else {
            return !this.supportedEvents.some((x) => x == event);
        }
    };
}
